import styled from 'styled-components';

export const HeaderNavOuterWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30}; 
    `
);

export const HeaderInnerWrap = styled.div(
    props => `
      width:100%;
      display: flex;
      height: 8rem;
      align-items: center;
      background-color: ${props.theme.colors.white.base};
      border-radius: 8px;
      box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
      padding: 0 ${props.theme.spacing.large.l30};
    `
);

export const HeaderNavWrap = styled.div(
    props => `
        width:80%;
        display: flex;
    `
);

export const HeaderNavWrapInner = styled.div(
    props => `
      width: 24%;
      display: flex;
      border-bottom: ${props.active ? `5px solid ${props.theme.colors.blue.base}` : '5px solid transparent'};
      align-items: center;
      justify-content: center;
      padding: ${props.theme.spacing.large.l21} 0;
      cursor: pointer;
    `
);

export const NavIconWrap = styled.div(
    props => `
        width:3.2rem;
        height: 3.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
    `
);

export const HeaderNavTextWrap = styled.div(
    props => `
        display: flex;
        flex-direction: column;
        padding-left: ${props.theme.spacing.base};
    `
);

export const HeaderNavMainText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.dark74};
        font-weight: ${props.theme.font.fontWeight.black};
        text-transform: ${props.theme.font.textTransform.capital};
    `
);

export const HeaderNavSubText = styled.p(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base1};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const BookingFindWrap = styled.div(
    props => `
        width:20%;
        display: flex;
        justify-content: flex-end;
        align-self: center;
    `
);

export const BookingFindBtn = styled.button(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.black};
        outline: none;
        border: none;
        background-color: ${props.theme.colors.white.base};
        border-radius: 20px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
        padding: ${props.theme.spacing.large.l12} ${props.theme.spacing.large.l20};
        cursor: pointer;
    `
);